import {NgModule} from '@angular/core';
import {HideFabModule} from '../../../shared/directives/hide-fab/hide-fab.module';

import {ImageListComponent} from './index';
import {IonicModule} from 'ionic-angular';
import {ImageListService} from "./services/image-list.service";
import {ImageService} from "../../../shared/services/advtech/image/image.service";
import {ContentTypeBadgeModule} from "../../../content/shared/components/content-type-badge/content-type-badge.module";
import {ContentStatusBadgeModule} from "../../../content/shared/components/content-status-badge/content-status-badge.module";
import {UserNameModule} from "../../../shared/components/user-name/user-name.module";

/**
 * Module for the ImageListComponent
 * @class
 */
@NgModule({
  declarations: [ImageListComponent],
  entryComponents: [ImageListComponent],
  exports: [ImageListComponent],
  imports: [
    IonicModule,
    ContentTypeBadgeModule,
    ContentStatusBadgeModule,
    UserNameModule,
    HideFabModule,
  ],
  providers: [ImageListService, ImageService],
})
export class ImageListModule {
}



// WEBPACK FOOTER //
// ./src/app/list/components/image-list/image-list.module.ts